import BookRow from "components/Bookcards/BookRow/BookRow";
import BookRowRanked from "components/Bookcards/BookRowRanked/BookRowRanked";
import UserBookHighlights from "components/Bookcards/UserBookByStatusCard/UserBookHighlights";
import BookHighlights from "components/BookRow/BookHighlights";
import {
  LetterbookListType,
  LetterbookSettingType,
} from "features/Letterbooks/types";

export default function LetterbookListRow({
  letterbook,
  settings,
}: {
  letterbook: LetterbookListType;
  settings: LetterbookSettingType;
}) {
  const { list } = settings.context;
  const { ownerUserBook } = letterbook.data;
  if (list.ranked) {
    return (
      <BookRowRanked
        size="sm"
        className="py-4 border-b border-gray-300 dark:border-gray-600"
        book={letterbook.book}
        rank={letterbook.position + 1}
      >
        <div className="flex flex-col space-y-2">
          <BookHighlights book={letterbook.book} />
          { ownerUserBook && (
            <UserBookHighlights userBook={ownerUserBook} book={letterbook.book} hideHighlights={true} dateAdded={false} />
          )}
        </div>
      </BookRowRanked>
    );
  }
  return (
    <BookRow
      size="sm"
      book={letterbook.book}
      className="py-4 border-b border-gray-300 dark:border-gray-600"
    >
      <div className="flex flex-col space-y-2">
        <BookHighlights book={letterbook.book} />
        { ownerUserBook && (
          <UserBookHighlights userBook={ownerUserBook} book={letterbook.book} hideHighlights={true} dateAdded={false} />
        )}
      </div>
    </BookRow>
  );
}
